var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"grey--text text--darken-4 text-body-2 font-weight-medium"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('VueEditor',_vm._g(_vm._b({staticClass:"text-body-2 font-weight-regular mt-1 textarea-editor",class:{ resize: !_vm.noResize },attrs:{"resize":""}},'VueEditor',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }